var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.questLibrary ? _c('div') : _c('v-list-item', {
    attrs: {
      "to": _vm.to
    }
  }, [_vm.collection ? [_c('v-list-item-avatar', {
    attrs: {
      "width": 48 * 4,
      "height": 48,
      "tile": ""
    }
  }, [_c('v-img', {
    staticClass: "quest-library-icon",
    attrs: {
      "src": _vm.questLibrary.icon,
      "contain": ""
    }
  })], 1), _c('v-list-item-content', [_c('v-list-item-subtitle')], 1)] : [_c('v-list-item-avatar', {
    staticClass: "mx-auto mr-2 mr-md-4",
    attrs: {
      "width": _vm.$size() * 4,
      "height": _vm.$size(),
      "tile": ""
    }
  }, [_c('v-img', {
    staticClass: "quest-library-icon",
    attrs: {
      "src": _vm.questLibrary.icon,
      "contain": ""
    }
  })], 1), _vm.questLibrary.badge ? _c('div', {
    staticClass: "mr-2 small",
    staticStyle: {
      "width": "64px"
    }
  }, [_c('KeyValue', {
    attrs: {
      "k": _vm.questLibrary.badge
    }
  })], 1) : _vm._e(), _c('v-list-item-content', {
    staticClass: "ml-0",
    style: {
      'max-width': _vm.questLibrary.badge ? '160px' : '240px'
    }
  }, [_c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.$name(_vm.questLibrary.name)))])], 1), _c('div', {
    staticClass: "mr-auto"
  })]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }